import request from '@/axios';

export const getPartnerList = (query) => {
  return request({
    url: '/lebo-partner/partner/page',
    method: 'GET',
    params: { ...query }
  })
}

export const getSuppliers = () => {
  return request({
    url: '/lebo-partner/partner/list',
    method: 'GET'
  })
}

export const submitPartnerInfo = (data) => {
  return request({
    url: '/lebo-partner/partner/submit',
    method: 'POST',
    data
  })
}

export const deletePartners = (data) => {
  return request({
    url: '/lebo-partner/partner/remove',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: data
  })
}
